/* eslint-disable no-undef */
import { StadiumFanAnalytics, AnalyticsInput } from '../../../types/inVenue';
import useAnalytics from './useAnalytics';

const useGenderBreakdownByGame = ({
    rightsholder,
    season,
    clientId,
    gameDates,
    sectionIds,
}: Omit<AnalyticsInput, 'groupBy'>) => {
    const { data: analytics, isLoading } = useAnalytics({
        clientId,
        rightsholder,
        season,
        gameDates,
        sectionIds,
        groupBy: ['gender', 'date'],
    });

    const genderBreakdownByDate = (analytics || []).reduce(
        (acc: any, curr: StadiumFanAnalytics) => {
            if (!acc[curr.gameDate]) {
                acc[curr.gameDate] = {
                    total: curr.fanCount,
                    [curr.gender.toLowerCase()]: curr.fanCount,
                };
            } else {
                acc[curr.gameDate].total += curr.fanCount;
                acc[curr.gameDate][curr.gender.toLowerCase()] = curr.fanCount;
            }
            return acc;
        },
        {},
    );

    return { data: genderBreakdownByDate, isLoading };
};

export default useGenderBreakdownByGame;
